import React,{Component} from 'react';
import { Layout , Form}  from 'antd'
import NavigationPane from './NavigationPane'
import LoginDetails from './LoginDetails'
//import AddCustomer from './AddCustomer/AddCustomer'
import Dashboard from './Dashboard/Dashboard'
import ViewSales from './ViewSales/ViewSales'
import AddSale from './AddSale/AddSale'
import Profile from './Profile/Profile'
// import ViewCustomers from './ViewCustomers/ViewCustomers'
import { BrowserRouter as Router , Route}  from 'react-router-dom'
import 'antd/dist/antd.css'
import ViewEmployees from './Employee/ViewEmployees/ViewEmployees'
import AddEmployeeWiz from './Employee/AddEmployee/AddEmployeeWiz'
import Payroll from './Employee/Payroll/Payroll'
import Attendance from './Attendance/Attendance';
import ViewVehicles from './Vehicle/ViewVehicles';
import { fetchEmployees } from '../Actions/EmployeeActions';
import ViewWarehouse from './Warehouse/ViewWarehouse';
import Routes from './Routes/Routes'
import Payslip from './Payslip';
import EditEmployee from './Employee/EditEmployee';
import Settings from './Pages/Settings';

const { Header, Content, Footer } = Layout;



class Home extends Component
{
    state = {
        loading : false
    }


    componentDidMount(){
        fetchEmployees()
    }
   
    render(){
   

        return(        
            <div>                 
                <Layout >  
                <Router basename="payroll" >             
                    <NavigationPane buttonEvent={this.opendetails}></NavigationPane>
                    <Layout style={{backgroundColor:"white"}} >
                        <Header style={{backgroundColor:"#f7f7f7"}} ><LoginDetails token={this.props.token}/></Header>
                        <Content>
                            <div style={{backgroundColor:"White", margin:"0px" , padding:"50px"}}>                            
                            <Route path="/addEmployee" component={AddEmployeeWiz}/>
                            <Route path="/viewemployees" component={ViewEmployees}/>
                            <Route path="/employee/:id/payroll" component={Payroll}/>
                            <Route path="/employee/:id/edit" component={EditEmployee}/>
                            <Route path="/payroll" component={Payroll}/>
                            <Route path="/attendance" component={Attendance}/>
                            <Route path='/vehicles' component={ViewVehicles}/>
                            <Route path='/warehouses' component={ViewWarehouse}/>
                            <Route path="/routes" component={Routes}/>
                            <Route path="/payslip" component={Payslip}/>
                            <Route path="/settings" component={Settings} />
                            </div>
                        </Content>
                        <Footer style={{backgroundColor:"white"}}>RIB Group</Footer>
                    </Layout>
                </Router> 
                </Layout>
            </div>
        );
    }


}

export default Home
